"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const escape_html_1 = __importDefault(require("escape-html"));
exports.default = {
    pedantic: false,
    mangle: true,
    smartLists: false,
    contentSizeLimit: null,
    minHeaderLevel: 1,
    escapeNotebooks: false,
    disableNotebooks: false,
    langPrefix: 'lang-',
    escape: (text) => {
        const escapedHTML = (0, escape_html_1.default)(text);
        // avoid parsing unicode defined characters and leave them as they are
        return escapedHTML.replace(/&amp;#([0-9]{1,3});/g, (_, code) => `&#${code};`);
    }
};
